<template lang="pug">
  v-datetime-picker(
    label="Дата окончания публикации (время локальное)"
    outlined
    hide-details
    background-color="white"
    dense
    v-model="model"
    :timePickerProps="{format: '24hr'}"

  )
</template>

<script>
/**
 * @displayName Publish date picker
 */
export default {
  name: 'publish-date-picker',
  props: {
    /**
     * @model Date string in ISO format 'year-month-date'
     */
    value: {
      type: Date,
      default: new Date()
    }
  },
  data() {
    return {
      dialog: false
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },

      set(val) {
        this.$emit('input', val)
        this.dialog = false
      }
    }
  }
}
</script>
